"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _FrostedBackdrop = _interopRequireDefault(require("../FrostedBackdrop"));
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    paper: {
      backgroundColor: 'transparent'
    }
  };
});
var GalleryModal = function GalleryModal(_ref2) {
  var isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    header = _ref2.header,
    children = _ref2.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "xl",
    open: isOpen,
    classes: classes,
    onClose: onClose,
    BackdropComponent: _FrostedBackdrop["default"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full py-10 px-40 m-0 overflow-hidden"
  }, header, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-8"
  }, children)));
};
var Header = exports.Header = function Header(_ref3) {
  var _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? 0 : _ref3$selected,
    selectAll = _ref3.selectAll,
    onSelectAll = _ref3.onSelectAll,
    view = _ref3.view,
    viewDisabled = _ref3.viewDisabled,
    onChangeView = _ref3.onChangeView,
    onClose = _ref3.onClose;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var isPendingCard = view === 'list' || view === 'gallery';
  var handleOnChangeView = function handleOnChangeView(e) {
    var nextView = e.target.value;
    onChangeView(nextView);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative flex justify-between text-lg font-semibold text-white"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onSelectAll,
    style: {
      fontWeight: 'inherit'
    },
    disabled: !isPendingCard || disabled,
    className: (0, _classnames["default"])({
      'pointer-events-none opacity-30': !isPendingCard
    })
  }, selectAll ? t('contactGallery.button.deselectAll') : t('contactGallery.button.selectAll')), isPendingCard && selected > 0 && /*#__PURE__*/_react["default"].createElement("div", null, t('contactGallery.selected', {
    count: selected
  })), /*#__PURE__*/_react["default"].createElement("select", {
    value: view,
    disabled: !isPendingCard || disabled || viewDisabled,
    onChange: handleOnChangeView,
    className: (0, _classnames["default"])('bg-transparent w-36', {
      'cursor-pointer': !viewDisabled && isPendingCard,
      'opacity-30': !isPendingCard
    }),
    style: {
      fontWeight: 'inherit'
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "gallery"
  }, t('contactGallery.view.gallery')), /*#__PURE__*/_react["default"].createElement("option", {
    value: "list"
  }, t('contactGallery.view.list'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute",
    style: {
      right: '-15%'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClose,
    className: "px-3 hover:opacity-75"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "large"
  }))));
};
var _default = exports["default"] = GalleryModal;
//# sourceMappingURL=GalleryModal.js.map